<template>
  <div class="rework-items-record">
    <div class="search-hd">
      <h1 class="item-title list-title">{{ $t('asm_rework_items.fan_gong_xiang') }}</h1>
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <!-- 搜索项 -->
        <el-form-item style="float: right; margin-right: 0;">
          <search-input
            v-model="formSearch.search"
            @fetch="onPageChange({ page: 1 })"
            :placeholder="$t('asm_rework_items.fgxljbh')"
          ></search-input>
        </el-form-item>
        <!-- 零件位置 -->
        <el-form-item
          style="float: right"
          v-if="caseInfo && caseInfo.bodyNum"
        >
          <custom-select
            url="ComponentReplaceComponentList"
            type="tree"
            v-model="formSearch.componentCode"
            :show-all-levels="false"
            :params="{ bodyNum: caseInfo.bodyNum }"
            :props="{
                    label: 'componentName',
                    value: 'componentCode',
                    emitPath: false,
                  }"
            width="100%"
            ref="component"
            :placeholder="$t('asm_rework_items.ling_jian_wei_zhi')"
            @treeValChange="onPageChange({ page: 1 })"
            @clear="onPageChange({ page: 1 })"
          ></custom-select>
        </el-form-item>
        <!-- 返工版本 -->
        <el-form-item
          style="float: right"
          v-if="caseInfo && caseInfo.productSn"
        >
          <custom-select
            url="BasicItemGroupItemVersions"
            :params="{ productSn: caseInfo.productSn }"
            v-model="formSearch.itemVersion"
            :dataFilter="versionsFilter"
            :placeholder="$t('asm_rework_items.fan_gong_ban_ben')"
            @change="onPageChange({ page: 1 })"
          ></custom-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="
              table-bd">
      <custom-table-expand
        ref="customTb1"
        index
        :rowId="getRowKeys"
        :data="tableList"
        :tableCode="tableCode"
        @sort="sortChange"
        @filter="filterChange"
        @exChange="exChange"
        expand-row-keys
        expand
        :slots="['expand']"
        height="100%"
      >
        <template
          slot="expand"
          slot-scope="scope"
        >
          <div class="part-pic ub">
            <div
              style="margin-right: 60px"
              v-if="scope.row.beforeFileList && scope.row.beforeFileList.length"
            >
              <h1>{{ $t('asm_rework_items.ghqtp') }}</h1>
              <ul class="ubw">
                <li
                  v-for="(item, index) in scope.row.beforeFileList"
                  :key="index"
                >
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="item.attachPath"
                    :preview-src-list="[item.attachPath]"
                    fit="contain"
                  >
                  </el-image>
                </li>
              </ul>
            </div>
            <div v-if="scope.row.afterFileList && scope.row.afterFileList.length">
              <h1>{{ $t('asm_rework_items.ghhtp') }}</h1>
              <ul class="ubw">
                <li
                  v-for="(item, index) in scope.row.afterFileList"
                  :key="index"
                >
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="item.attachPath"
                    :preview-src-list="[item.attachPath]"
                    fit="contain"
                  >
                  </el-image>
                </li>
              </ul>
            </div>
          </div>
        </template>
      </custom-table-expand>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customTableExpand from '@/components/customTableExpand.vue';

export default {
  inject: ['getCaseInfo'],
  computed: {

    tableCode() {
      return 'rework_items_record';
    },
  },
  components: { customTableExpand },
  props: {
    orderTechnicianId: [Number, String],
    orderType: [String], // workOrder是工单  caseOrder是案例订单
    // workOrderId: [Number, String]
  },

  watch: {

  },

  data() {
    return {
      formSearch: {
        search: '',
        componentCode: '',
        itemVersion: '',
      },
      tableList: [],

      // 发票列表
      invoiceList: [],
      expandedlist: [],
      // 获取row的key值
      getRowKeys(row) {
        return row.itemId;
      },
      ratingInfo: {},
      caseInfo: {},
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    versionsFilter(list) {
      function fitler(item) {
        if (typeof item === 'string') {
          return {
            name: item,
            value: item,
          };
        } else {
          return item;
        }
      }
      const ret = list.map(fitler);
      return ret;
    },

    onPageChange() {
      this.getTableList();
    },
    initDialog: function () {
      this.caseInfo = this.getCaseInfo();

      this.getTableList();
    },

    getReqData() {
      const reqData = {
        ...this.formSearch
      };
      if (this.caseInfo.workOrderId) {
        reqData.workOrderId = this.caseInfo.workOrderId;
      } else {
        reqData.caseOrderId = this.caseInfo.caseOrderId;
      }
      return reqData;
    },

    getTableList: function () {
      this.$getJSON(apis.caseOrderItemReworkItems, this.getReqData()).then((res) => {
        this.tableList = res.data || [];
      });
    },
    exChange: function (row) {
      this.getAttachList(row);
    },
    // 获取零件变更图片
    getAttachList: async function (item) {
      if (!item.orderPartId) {
        return;
      }
      await Promise.all([this.$getJSON(`${apis.OssAttach}/${item.orderPartId}/asm.service.part.old`), this.$getJSON(`${apis.OssAttach}/${item.orderPartId}/asm.service.part.new`)]).then(([beforeFileList, afterFileList]) => {
        beforeFileList.data.map(f => this.getAttachUrl(f));
        afterFileList.data.map(f => this.getAttachUrl(f));
        this.$set(item, 'beforeFileList', beforeFileList.data);
        this.$set(item, 'afterFileList', afterFileList.data);
      });
    },
    getRatingInfo: function () {
      this.$getJSON(apis.ratingDeviceInfo, {
        // orderTechnicianId: this.orderTechnicianId,
        bodyNum: this.caseInfo.bodyNum,
        workOrderId: this.caseInfo.workOrderId,
      }).then((res) => {
        this.ratingInfo = res.data || {};
        if (this.ratingInfo.ratingImg) {
          this.$getAttachFileList(this.ratingInfo.ratingImg).then((imageList) => {
            this.ratingInfo.imageList = imageList;
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.rework-items-record {
  display: flex;
  height: 100%;
  padding: 16px;
  padding-top: 0;
  flex-direction: column;

  .list-title {
    float: left;
    margin-top: 5px;
    margin-bottom: 0;
  }

  .el-table__expanded-cell {
    padding: 0;
  }
  .record-detail {
    padding: 20px 0;
  }
  .part-pic {
    padding: 16px;
    h1 {
      font-weight: bold;
      line-height: 17px;
      margin-bottom: 10px;

      font-size: 12px;
      color: #495057;
      line-height: 17px;
    }
    ul li{
      cursor: pointer;
    }
    // ul li img {
    //   width: 60px;
    //   height: 60px;
    //   border-radius: 2px;
    //   // border: 1px solid rgba(238, 238, 238, 1);
    //   margin-right: 16px;
    // }
  }
}
</style>
